import CryptoJS from "crypto-js";

const COPYRIGHT = "Twiage";

export const SecureStorage = {
  storage: window.localStorage,

  hash: function hash(key) {
    key = CryptoJS.SHA256(key, COPYRIGHT);
    return key.toString();
  },

  encrypt: function encrypt(data) {
    data = CryptoJS.AES.encrypt(data, COPYRIGHT);
    data = data.toString();
    return data;
  },

  decrypt: function decrypt(data) {
    data = CryptoJS.AES.decrypt(data, COPYRIGHT);
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
  },

  getItem: function getItem(key) {
    const ekey = this.hash(key);
    let evalue = this.storage.getItem(ekey);
    if (typeof evalue !== "string") {
      return evalue;
    }
    evalue = this.decrypt(evalue);
    return JSON.parse(evalue!);
  },

  setItem: function setItem(key, value) {
    const ekey = this.hash(key);
    let evalue = JSON.stringify(value);
    evalue = this.encrypt(evalue);
    return this.storage.setItem(ekey, evalue);
  },

  removeItem: function removeItem(key) {
    key = this.hash(key);
    return this.storage.removeItem(key);
  },

  clear: function clear() {
    return this.storage.clear();
  },

  key: function key(id) {
    return this.storage.key(id);
  },
};
